import React, { FC } from 'react';
import { useFileType } from '../../../../utils/hooks/bi/useFileType';
import { Connected } from '../Connected';
import { NotConnected } from '../NotConnected';
import { IFilesViewerOuter } from './FilesViewer.types';

// TODO this component has a lot similar (breadcrumbs, infinite scroll, footer, loaders, styles) with Move To modal.
// It should be separated to component. https://jira.wixpress.com/browse/MMGR6-402

export const FilesViewer: FC<IFilesViewerOuter> = ({
  className,
  isConnected,
  source,
  connectorsMap,
  onConnectClicked,
  onSelect,
  openedFrom,
  onSourceSessionExpired,
  folderPath,
}) => {
  const fileType = useFileType();
  const isConnectableSource = Boolean(connectorsMap[source]);

  return isConnectableSource && !isConnected ? (
    <NotConnected source={source} onConnectClicked={onConnectClicked} />
  ) : (
    <Connected
      initialFolderPath={folderPath}
      folderPath={folderPath}
      source={source}
      className={className}
      onSelect={onSelect}
      openedFrom={openedFrom}
      fileType={fileType}
      onSourceSessionExpired={onSourceSessionExpired}
    />
  );
};
